var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.menuPermission ? _c('div', [_vm.hasOneShowingChild(_vm.item.children, _vm.item) && (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) && !_vm.item.alwaysShow ? [_vm.onlyOneChild.meta ? _c('router-link', {
    attrs: {
      "to": _vm.resolvePath(_vm.onlyOneChild.path)
    }
  }, [_c('el-menu-item', {
    class: {
      'submenu-title-noDropdown': !_vm.isNest
    },
    attrs: {
      "index": _vm.resolvePath(_vm.onlyOneChild.path)
    }
  }, [_c('div', {
    staticClass: "sidebar-item"
  }, [_vm._v(" " + _vm._s(_vm.onlyOneChild.meta.title) + " ")])])], 1) : _vm._e()] : _c('el-submenu', {
    ref: "subMenu",
    attrs: {
      "popper-class": "sub-menu",
      "index": _vm.resolvePath(_vm.item.path)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm.item.meta ? _c('div', {
    staticClass: "sidebar-item"
  }, [_vm._v(" " + _vm._s(_vm.item.meta.title) + " "), _c('img', {
    staticClass: "active",
    attrs: {
      "src": require("../../../assets/z-1.png"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "passive",
    attrs: {
      "src": require("../../../assets/spread-2.png"),
      "alt": ""
    }
  })]) : _vm._e()]), _vm._l(_vm.item.children, function (child) {
    return _c('nav-menu-item', {
      key: child.path,
      staticClass: "nest-menu",
      attrs: {
        "is-nest": true,
        "item": child,
        "base-path": _vm.resolvePath(child.path)
      }
    });
  })], 2)], 2) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };